import {
    LOAD_FLOOR_LOCATION_V2_METRICS_CALL_BEGIN,
    LOAD_FLOOR_LOCATION_V2_METRICS_CALL_FAILURE, LOAD_NODE_RESOURCE_DATA_FOR_FLOOR_LOCATION_V2,
    LOAD_STOW_BAG_METRICS_FOR_FLOOR_LOCATION_V2, LOAD_STOW_BIN_METRICS_FOR_FLOOR_LOCATION_V2,
    LOAD_STOW_CART_METRICS_FOR_FLOOR_LOCATION_V2,
    LOAD_STOW_PACKAGE_METRICS_FOR_FLOOR_LOCATION_V2
} from "../actions/FloorLocationActionsV2";
import {getNodeResourceDataMap} from "../Utility";


/**
 * Initial state of the system.
 */
const initialState = {
    loading: false,
    stowPackageMetricsMap: {},
    inductPackageMetricsMap: {},
    stowCartMetricsMap: {},
    stowBagMetricsMap: {},
    nodeResourceDataMap: new Map(),
    stowBinMetricsMap: {}
}


export default function floorLocationReducerV2(state = initialState, action) {
    switch (action.type) {
        case LOAD_FLOOR_LOCATION_V2_METRICS_CALL_BEGIN:
            return {
                ...state,
                loading: true
            };
        case LOAD_STOW_PACKAGE_METRICS_FOR_FLOOR_LOCATION_V2:
            return {
                ...state,
                loading: false,
                stowPackageMetricsMap: action.stowPackageMetricsMap
            };
        case LOAD_STOW_CART_METRICS_FOR_FLOOR_LOCATION_V2:
            return {
                ...state,
                loading: false,
                stowCartMetricsMap: action.stowCartMetricsMap
            };
        case LOAD_STOW_BAG_METRICS_FOR_FLOOR_LOCATION_V2:
            return {
                ...state,
                loading: false,
                stowBagMetricsMap: action.stowBagMetricsMap
            };
        case LOAD_NODE_RESOURCE_DATA_FOR_FLOOR_LOCATION_V2:
            return {
                ...state,
                loading: false,
                nodeResourceData: action.nodeResourceData,
                nodeResourceDataMap: getNodeResourceDataMap(action.nodeResourceData)
            };
        case LOAD_STOW_BIN_METRICS_FOR_FLOOR_LOCATION_V2:
            return {
                ...state,
                loading: false,
                stowBinMetricsMap: action.stowBinMetricsMap
            };
        case LOAD_FLOOR_LOCATION_V2_METRICS_CALL_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/FloorLocationReducerV2.js